import { render, staticRenderFns } from "./AdminPageFrame.vue?vue&type=template&id=27dd288a"
import script from "./AdminPageFrame.vue?vue&type=script&lang=js"
export * from "./AdminPageFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports